import { render } from "./AktuelleEftersyn.vue?vue&type=template&id=059c578c&scoped=true"
import script from "./AktuelleEftersyn.vue?vue&type=script&lang=js"
export * from "./AktuelleEftersyn.vue?vue&type=script&lang=js"

import "./AktuelleEftersyn.vue?vue&type=style&index=0&id=059c578c&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059c578c"]])

export default __exports__